module.exports = __webpack_public_path__ + "img/horizontal_6_6_pp13_8004.eea2601a.png";